import type { TemplateView } from '@ps/isp-web-services-types';
import React from 'react';

import { isEventTemplate } from '@swf/sports/types/templates';
import { isCompoundMarketTemplate } from '@swf/sports/utils/isCompoundMarketTemplate';

import CompoundMarketTemplatePanel from './components/TemplatePanel/CompoundMarketTemplatePanel';
import EventTemplatePanel from './components/TemplatePanel/EventTemplatePanel';
import MarketTemplatePanel from './components/TemplatePanel/MarketTemplatePanel';

interface Props {
  groups: TemplateView[][][];
  groupedOn?: 'DATE' | 'COMPETITION';
  isNested?: boolean;
  flush?: boolean;
}

const GroupedTemplatePanels: React.FC<Props> = ({
  groups,
  groupedOn = 'COMPETITION',
  isNested = false,
  flush: isFlush = false
}) => (
  <>
    {groups.map((competitionGroup) => {
      const firstTemplateInPanel = competitionGroup[0][0].template;

      if (isCompoundMarketTemplate(firstTemplateInPanel))
        return (
          <CompoundMarketTemplatePanel
            key={`${firstTemplateInPanel.marketIds.join(',')}_template_panel`}
            competitionGroup={competitionGroup}
            groupedOn={groupedOn}
            marketIds={firstTemplateInPanel.marketIds}
            isNested={isNested}
            flush={isFlush}
          />
        );

      if (isEventTemplate(firstTemplateInPanel)) {
        return (
          <EventTemplatePanel
            key={`${firstTemplateInPanel.eventId}_template_panel`}
            competitionGroup={competitionGroup}
            groupedOn={groupedOn}
            eventId={firstTemplateInPanel.eventId}
            isNested={isNested}
            flush={isFlush}
          />
        );
      }

      return (
        <MarketTemplatePanel
          key={`${firstTemplateInPanel.marketId}_template_panel`}
          competitionGroup={competitionGroup}
          groupedOn={groupedOn}
          marketId={firstTemplateInPanel.marketId}
          isNested={isNested}
          flush={isFlush}
        />
      );
    })}
  </>
);

export default GroupedTemplatePanels;
